// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__319q5","container__footerMobile":"style_container__footerMobile__eTdta"};